import { API_BASE_URL } from './api';
import { authService } from './authService';

export interface Mute {
  muterUserId: string;
  mutedUserId: string;
  createdAt: string;
}

const authJsonHeaders = () => ({ 'Content-Type': 'application/json', ...authService.getAuthHeaders() });

// One-directional and silent — the muted user is never told. Only changes what the muter
// sees: their own buddies/followers feed stops surfacing the muted user's posts, and
// reaction/comment/tag notifications from the muted user stop firing. Does not un-buddy or
// un-follow, and (unlike a block) never hides the muter's own content from the muted user.
export const muteService = {
  mute: async (mutedUserId: string): Promise<Mute> => {
    const res = await fetch(`${API_BASE_URL}/mutes`, {
      method: 'POST',
      headers: authJsonHeaders(),
      body: JSON.stringify({ mutedUserId }),
    });
    if (!res.ok) throw new Error(await res.text() || 'Failed to mute user');
    return res.json();
  },

  unmute: async (mutedUserId: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/mutes/${encodeURIComponent(mutedUserId)}`, {
      method: 'DELETE',
      headers: { ...authService.getAuthHeaders() },
    });
    if (!res.ok) throw new Error('Failed to unmute user');
  },

  getMutes: async (): Promise<Mute[]> => {
    const res = await fetch(`${API_BASE_URL}/mutes`, { headers: { ...authService.getAuthHeaders() } });
    if (!res.ok) throw new Error('Failed to load muted accounts');
    return res.json();
  },
};
